module.exports = __webpack_public_path__ + "static/media/surport.28c2fc75.svg";